import { render } from "./App.vue?vue&type=template&id=b4a826f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b4a826f8&lang=scss"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__